/**
 * Created by razial on 28.05.2026.
 */

const EditorMap2dBackgroundBaker = function (editor) {
    this.editor = editor;
    this.map = editor.map;
    this.mapView = editor.map.getMapView();

    this.partSize = { width: 2048, height: 2048 };

    this.format = this.detectImageFormat();
};

EditorMap2dBackgroundBaker.prototype.bake = function () {
    const player = new ActionPlayer([
        (f) => {
            cleverapps.loading.show();
            f();
        },

        (f, stop) => {
            if (typeof JSZip !== "undefined") {
                f();
                return;
            }

            cleverapps.loadSdk("//cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js", {
                onSuccess: f,
                onFailure: function () {
                    cleverapps.notification.create("Failed to load JSZip");
                    stop();
                }
            });
        },

        (f) => {
            setTimeout(() => {
                this.bakeParts();
                f();
            }, 150);
        }
    ]);

    player.onComplete(() => {
        cleverapps.loading.hide();
    });

    player.play();
};

EditorMap2dBackgroundBaker.prototype.bakeParts = function () {
    const restore = this.prepare();

    try {
        this.forceShowWholeMap();

        const folder = Map2d.getBackgroundBundles(cleverapps.meta.selectedLocationId());
        const zip = new JSZip();

        const parts = this.calcParts();
        parts.forEach((part) => {
            const dataUrl = this.bakePart(part);
            if (dataUrl) {
                zip.file(`${folder}/background_${part.row}_${part.col}.${this.format.ext}`, dataUrl.split(",")[1], { base64: true });
            }
        });

        zip.generateAsync({ type: "blob" }).then((content) => {
            const link = document.createElement("a");
            link.href = URL.createObjectURL(content);
            link.download = `${folder}.zip`;
            link.click();
            link.remove();
            URL.revokeObjectURL(link.href);

            cleverapps.loading.hide();
        });
    } finally {
        restore();
    }
};

EditorMap2dBackgroundBaker.prototype.detectImageFormat = function () {
    try {
        const canvas = document.createElement("canvas");
        canvas.width = 1;
        canvas.height = 1;

        if (canvas.toDataURL("image/webp").startsWith("data:image/webp")) {
            return { mime: "image/webp", ext: "webp" };
        }
    } catch (e) {
        // do nothing
    }

    return { mime: "image/jpeg", ext: "jpg" };
};

EditorMap2dBackgroundBaker.prototype.prepare = function () {
    this.editor.unselect();

    const mapView = this.mapView;
    const saved = {
        anchor: mapView.getAnchorPoint(),
        position: mapView.getPosition(),
        scaleX: mapView.getScaleX(),
        scaleY: mapView.getScaleY()
    };

    const transform = mapView.getParent().getNodeToWorldTransform();
    const backgroundScale = this.map.getBackgroundScale();
    this.viewTransform = {
        a: transform.a * backgroundScale.x,
        d: transform.d * backgroundScale.y,
        tx: transform.tx * backgroundScale.x,
        ty: transform.ty * backgroundScale.y
    };
    this.contentPartSize = {
        width: this.partSize.width * backgroundScale.x,
        height: this.partSize.height * backgroundScale.y
    };

    mapView.setAnchorPoint(0, 0);
    mapView.setScale(1 / this.viewTransform.a, 1 / this.viewTransform.d);

    const winSize = { width: cc.director._winSizeInPoints.width, height: cc.director._winSizeInPoints.height };
    cc.director._winSizeInPoints = cc.size(this.partSize.width, this.partSize.height);

    return () => {
        cc.director._winSizeInPoints = cc.size(winSize.width, winSize.height);

        mapView.setAnchorPoint(saved.anchor);
        mapView.setScale(saved.scaleX, saved.scaleY);
        mapView.setPosition(saved.position);
    };
};

EditorMap2dBackgroundBaker.prototype.addDebugGrid = function () {
    const mapView = this.mapView;
    const step = 512;
    const red = cc.color(255, 0, 0, 255);

    const grid = new cc.DrawNode();

    const cols = Math.ceil(mapView.width / step);
    const rows = Math.ceil(mapView.height / step);

    for (let i = 0; i <= cols; i++) {
        grid.drawSegment(cc.p(i * step, 0), cc.p(i * step, mapView.height), 3, red);
    }
    for (let j = 0; j <= rows; j++) {
        grid.drawSegment(cc.p(0, j * step), cc.p(mapView.width, j * step), 3, red);
    }

    for (let i = 0; i < cols; i++) {
        for (let j = 0; j < rows; j++) {
            const label = new cc.LabelTTF(`${i},${j}`, "Arial", 64);
            label.setColor(red);
            label.setAnchorPoint(0.5, 0.5);
            label.setPosition(i * step + step / 2, j * step + step / 2);
            grid.addChild(label);
        }
    }

    mapView.addChild(grid, 99999);

    return grid;
};

EditorMap2dBackgroundBaker.prototype.forceShowWholeMap = function () {
    for (let y = 0; y < this.map.getHeight(); y++) {
        for (let x = 0; x < this.map.getWidth(); x++) {
            this.map.showTile(x, y);
        }
    }
};

EditorMap2dBackgroundBaker.prototype.calcParts = function () {
    const mapView = this.mapView;
    const partSize = this.contentPartSize;

    const bbox = this.calcTilesBoundingBox();

    const minCol = Math.floor((bbox.minX - mapView.width / 2) / partSize.width);
    const maxCol = Math.ceil((bbox.maxX - mapView.width / 2) / partSize.width);
    const minRow = Math.floor((bbox.minY - mapView.height / 2) / partSize.height);
    const maxRow = Math.ceil((bbox.maxY - mapView.height / 2) / partSize.height);

    const parts = [];
    for (let row = minRow; row <= maxRow; row++) {
        for (let col = minCol; col <= maxCol; col++) {
            parts.push({ row, col });
        }
    }
    return parts;
};

EditorMap2dBackgroundBaker.prototype.calcTilesBoundingBox = function () {
    const mapView = this.map.getMapView();
    const cell = cleverapps.styles.Map2dView.cell;
    const corners = [
        mapView.alignInGrid(0, 0),
        mapView.alignInGrid(this.map.getWidth() - 1, 0),
        mapView.alignInGrid(0, this.map.getHeight() - 1),
        mapView.alignInGrid(this.map.getWidth() - 1, this.map.getHeight() - 1)
    ];

    return {
        minX: Math.min.apply(null, corners.map((p) => p.x)) - cell.width / 2,
        maxX: Math.max.apply(null, corners.map((p) => p.x)) + cell.width / 2,
        minY: Math.min.apply(null, corners.map((p) => p.y)) - cell.height / 2,
        maxY: Math.max.apply(null, corners.map((p) => p.y)) + cell.height / 2
    };
};

EditorMap2dBackgroundBaker.prototype.bakePart = function (part) {
    const mapView = this.mapView;
    const partSize = this.contentPartSize;
    const pixelSize = this.partSize;

    const transform = this.viewTransform;

    const centerX = mapView.width / 2 + partSize.width * part.col;
    const centerY = mapView.height / 2 + partSize.height * part.row;

    mapView.setPosition(
        (-(centerX - partSize.width / 2) - transform.tx) / transform.a,
        (-(centerY - partSize.height / 2) - transform.ty) / transform.d
    );

    const rt = new cc.RenderTexture(pixelSize.width, pixelSize.height);
    rt.setAnchorPoint(0, 0);
    rt.setPosition(0, 0);

    rt.begin();
    mapView.visit();
    rt.end();

    return this.renderTextureToDataURL(rt, pixelSize.width, pixelSize.height);
};

EditorMap2dBackgroundBaker.prototype.renderTextureToDataURL = function (rt, width, height) {
    const gl = cc._renderContext;

    const pixels = new Uint8Array(width * height * 4);
    gl.bindFramebuffer(gl.FRAMEBUFFER, rt._renderCmd._fBO);
    gl.readPixels(0, 0, width, height, gl.RGBA, gl.UNSIGNED_BYTE, pixels);
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);

    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;

    const ctx = canvas.getContext("2d");
    const image = ctx.createImageData(width, height);

    const rowBytes = width * 4;
    for (let row = 0; row < height; row++) {
        const src = row * rowBytes;
        const dst = (height - row - 1) * rowBytes;
        image.data.set(pixels.subarray(src, src + rowBytes), dst);
    }
    ctx.putImageData(image, 0, 0);

    return canvas.toDataURL(this.format.mime, 0.9);
};
